const mapStateToProps = (state) => {
    const {
        ui:{
            selectedGeoObjArray,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
        }={},
        api:{
            geoObjReport,
            workingTimeSheet,
            geoObjVisits,
        }={},
        service:{
            Api:{
                getGeoObjReport,
                getWorkingTimeSheet,
                getGeoObjVisits,

            }={}
        }={}
    } = state;
    return {
        selectedGeoObjArray, 
        getGeoObjReport, 
        getWorkingTimeSheet, 
        getGeoObjVisits, 
        geoObjReport, 
        workingTimeSheet, 
        geoObjVisits, 
        dateRangeCriteria, 
        rangeStartDate, 
        rangeEndDate, 
    }
}

export default mapStateToProps;